<button class="rs-link-action rs-link-action-add" aria-haspopup="true">
  <span class="rs-link-action-label" aria-hidden="true">{{
    'create.mailbox.title' | translate
  }}</span
  ><span class="rs-action-link-icon" title="{{ 'create.mailbox.title' | translate }}"
    ><span class="show-for-sr">{{ 'create.mailbox.title' | translate }}</span></span
  >
</button>
